import React from 'react';
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';
import axios from 'axios'
//LAYOUT
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Spinner } from '../../../components-core/packages/components-core/dist/spinner';

import {  Layout } from '../../../components-core/packages/components-core/dist/layout/index';

import {
    Text,
    TextAppearance,
    TextColor
} from '../../../components-core/packages/components-core/dist/text';

//INPUT
import { TextInput, TextInputAppearance } from '../../../components-core/packages/components-core/dist/text-input';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';


//CUSTOM COMPONENTS
import ResultRow from './inner-components/ResultRow';
import TitleSection from './inner-components/TitleSection';


const Border = styled.div`
    border: 1px solid #000;
`;

const Line = styled.div`
    background-color: #c2cacf;
    width: 100%;
    height: 1px;
`;


class FramedQuery extends React.Component {

    constructor() {
        super();
        this.state = {
            listData: [],
            token: '',
            plaka: '',
            progressBarVisible: false,
            dataVisible: false,

        }
        // 
        const tokenurl = "https://ticariaracwebapi.vw.com.tr/api/Authorization/RequestToken"

        const authObject = {
            auth: {
                username: 'VwTicariWebApi',
                password: '^UzpqTUoqC5@JR@2Dk&y'
            }
        };


        axios.post(tokenurl, { "Access-Control-Allow-Origin": "*", "Access-Control-Allow-Methods": "POST, GET, OPTIONS" }, authObject).then(response => {

            this.state.token = 'Bearer '.concat(response.data.token);

        })
            .catch(error => {

            })



    }

    renderResults() {
        const datasetLength = this.state.listData.length;
        

           const renderedRows = this.state.listData.map((data, index) => [
                <ResultRow  data={data}/>,
                index + 1 !== datasetLength ? renderLine() : undefined
            ])
        

        return (
            <Container
                wrap={ContainerWrap.always}
                padding={resultsContainerPadding}
            >
                {renderedRows}
            </Container>
        )
    }

    changeHandler = (e) => {
        this.setState({ plaka: e.target.value })
    }

    // https://cors-anywhere.herokuapp.com/
    submitHandler = e => {
        e.preventDefault()
        this.setState({ progressBarVisible: true })
        let urlPost = "https://ticariaracwebapi.vw.com.tr/api/Turkuaz/ListPackages/"+this.state.plaka;

        axios.get(urlPost, { headers: { Authorization: this.state.token, "Access-Control-Allow-Origin": "*", "Access-Control-Allow-Methods": "POST, GET, OPTIONS", "X-Requested-With": "XMLHttpRequest", "Content-type": "application/json; charset=utf-8" } })
            .then(response => {
             
                this.setState({ listData: response.data.result.data });
                this.setState({ progressBarVisible: false })
                this.setState({ dataVisible: true })
            })
            .catch(error => {
                this.setState({ progressBarVisible: false })

            })

    }


    render() {
        return (
            <Container padding={topContainerPadding} stretchContent={true}>
                <Border>
                    <Container
                        padding={innerContainerPadding}
                        wrap={ContainerWrap.always}
                        gutter={ContainerGutter.dynamic0150}
                    >
                        <TitleSection />
                        <Container
                            wrap={ContainerWrap.always}
                            horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                            gutter={ContainerGutter.static200}
                        >
                            <form onSubmit={this.submitHandler}>
                                <TextInput
                                    type="text"
                                    name="sorgula"
                                    label="Plaka giriniz"
                                    placeholder="34AA123 formatında giriniz"
                                    onChange={event => {
                                        let value = event.target.value.split(' ').join('')
                                        this.setState({ plaka: value})
                                    }
                                    }

                                /><br/>
                                <Container
                                 wrap={ContainerWrap.never}
                                 gutter={ContainerGutter.static100}
                                >
                                <Button type="submit">Ara</Button>
                                {this.state.progressBarVisible ? <Spinner variant={'large'} /> : ''}
                                </Container>
                                
                            </form>

                            {this.state.dataVisible ? this.renderResults(this.state.listData) : ''}
                        </Container>
                    </Container>
                </Border>
            </Container>
        )
    }
}


const renderLine = () => (
    <Container
        stretchContent={true}
        padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }}
    >
        <Line />
    </Container>
)



const topContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004,
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004,
    },
}

const innerContainerPadding = {
    top: { [Breakpoints.default]: ContainerPadding.dynamic0200 },
    right: { [Breakpoints.default]: ContainerPadding.dynamic0200 },
    bottom: { [Breakpoints.default]: ContainerPadding.dynamic0270 },
    left: { [Breakpoints.default]: ContainerPadding.dynamic0200 },
}

const resultsContainerPadding = {
    left: {
        [Breakpoints.default]: null,
        [Breakpoints.b960]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: null,
        [Breakpoints.b960]: ContainerPadding.grid002
    }
}




const dummyData = [
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
]


export default FramedQuery;